<mat-card class="card-container">
    <mat-card-content class="card-body">
    <div class="row outline">
        <div class="col-md-6">
            <h1 class="mat-h2 left-text">{{projectHeader}}</h1>
        </div>

    </div>

    <div class="row outline">
        <div class="col-md-2 col-width1 app-h3">Request</div>
        <div class="col-md-1 col-width2 app-h3 chk-point-col">Checkpoint</div>
        <div class="col-md-3 col-width3 app-h3 title-col">Subject</div>
        <div class="col-md-2 col-width4 app-h3">Requestor</div>
        <div class="col-md-2 col-width5 app-h3">Department</div>
        <div class="col-md-2 col-width6 app-h3">Submitted Date</div>

    </div>
    <div class="project-type ">{{REQUEST_TYPE_CONSULTATION_VALUE}}</div>
    <div (click)="goto(rec)" class="row outline" *ngFor="let rec of consultationWorkRequests; index as i; first as isFirst">
        <div class="col-md-2 col-width1 col-text" matTooltipClass="wrNumberTooktip" matTooltip="click to view request." matTooltipPosition="right">{{rec.wrNumber}} </div>
        <div class="col-md-1 col-width2 {{rec.checkpoint}} col-text">{{decodeStatus(rec.checkpoint!,true)}}</div>
        <div class="col-md-3 col-width3 col-text">{{rec.subject}}</div>
        <div class="col-md-2 col-width4 col-text">{{rec.requestorName | azureName}}</div>
        <div class="col-md-2 col-width5 col-text">{{rec.department}}</div>
        <div class="col-md-2 col-width6 col-text">{{rec.submittedDateUTC?.toString()| utcToLocalTime:'shortDate'}}</div>
       
    </div>
    <div class="project-type">{{REQUEST_TYPE_WORK_ORDER_VALUE}}s</div>
    <div (click)="goto(rec)" class="row outline" *ngFor="let rec of WorkOrders; index as i; first as isFirst">
        <div class="col-md-2 col-width1 col-text"  matTooltipClass="wrNumberTooktip" matTooltip="click to view request."  matTooltipPosition="right">{{rec.wrNumber}}</div>
        <div class="col-md-1 col-width2 {{rec.checkpoint}} col-text">{{decodeStatus(rec.checkpoint!,true)}}</div>
        <div class="col-md-3 col-width3 col-text">{{rec.subject}}</div>
        <div class="col-md-2 col-width4 col-text">{{rec.requestorName| azureName}}</div>
        <div class="col-md-2 col-width5 col-text">{{rec.department}}</div>
        <div class="col-md-2 col-width6 col-text">{{rec.submittedDateUTC?.toString()| utcToLocalTime:'shortDate' }}</div>
       
    </div>    
    <div class="legend-div">
        <b>Legend |
            <span class="Assessing legend">&nbsp;A&nbsp;</span> In-Progress Assessing
            <span class="Fulfillment legend">&nbsp;F&nbsp;</span> Fulfillment
            <span class="Cancelled legend ">&nbsp;X&nbsp;</span> Cancelled
            <span class="Closed legend">&nbsp;C&nbsp;</span> Closed
            <span class="Queued legend">&nbsp;Q&nbsp;</span> Queued
        </b>
        <span class="info">Click on row to view request details.</span> 
    </div>
</mat-card-content>
</mat-card>